import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';
import type { LossAndDamageClaimCustomerSettings } from '../../types';

export const getLDClaimsCustomerSettingsAPI = () => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/GetCustomerSetting`,
    method: 'get',
  });
};

export type LDClaimsCustomerSettingsResponse = LossAndDamageClaimCustomerSettings;

export const fetchLDClaimsCustomerSettings = async (): Promise<LDClaimsCustomerSettingsResponse> => {
  const response: AxiosResponse<LDClaimsCustomerSettingsResponse> = await getLDClaimsCustomerSettingsAPI();
  return response.data;
};
